export default[
  {
    path: '/dataList/staffKPISalary',
    component: resolve => require(['../page.vue'], resolve),
    meta: {
        title: '店长绩效奖金',
        authLogin: true
    }
  },
]